import { render, staticRenderFns } from "./VxBreadcrumb.vue?vue&type=template&id=66f1f6bc&functional=true&"
import script from "./VxBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./VxBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports